import { FileWriteBehaviorEnum } from "../types/outputDestinationsTypes";

export const getFileWriteBehaviorName = (behavior: FileWriteBehaviorEnum): string => {
  switch (behavior) {
    case FileWriteBehaviorEnum.OVERWRITE:
      return "Overwrite";
    case FileWriteBehaviorEnum.ADDNUMERATOR:
      return "Add Numerator";
    case FileWriteBehaviorEnum.SKIP:
      return "Skip";
    case FileWriteBehaviorEnum.APPEND:
      return "Append";
    default:
      return "Unknown";
  }
};
